
import { Recipe } from "@/components/Recipe";
import RecipeFeedback from "@/components/recipe/RecipeFeedback";
import { ConversionResult } from "@/types/recipe";

interface RecipeSectionProps {
  recipe: ConversionResult | null;
  originalInput: { url?: string; text?: string };
  onPrint: () => void;
}

const RecipeSection = ({ recipe, originalInput, onPrint }: RecipeSectionProps) => {
  if (!recipe) return null;

  return (
    <>
      <Recipe 
        {...recipe}
        onPrint={onPrint}
        recipeId=""
        userId=""
        author={{
          username: "AI Assistant",
          avatarUrl: null
        }}
        nutritionalValues={null}
      />
      <RecipeFeedback 
        conversionResult={recipe}
        originalInput={originalInput}
      />
    </>
  );
};

export default RecipeSection;
